export default __webpack_public_path__ + "static/media/time_img.3e511a41.png";